(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDeviceReleasesDialogController', TabDeviceReleasesDialogController);

    TabDeviceReleasesDialogController.$inject = ['$state','$timeout', '$scope', 'entity', 'TabDeviceReleases', 'TabDevices','ParseLinks','AlertService'];

    function TabDeviceReleasesDialogController($state,$timeout, $scope, entity, TabDeviceReleases, TabDevices,ParseLinks,AlertService) {
        var vm = this;
        vm.tabDeviceReleases = entity;
        vm.devices = [];
        vm.page = 0;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabDeviceReleasesUpdate', result);
            vm.isSaving = false;
            $state.go('tab-device-releases');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabDeviceReleases.id !== null) {
                TabDeviceReleases.update(vm.tabDeviceReleases, onSaveSuccess, onSaveError);
            } else {
                TabDeviceReleases.save(vm.tabDeviceReleases, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('tab-device-releases');
        };

        vm.loadAll = function () {

            TabDevices.query({
                filter: 'tabdevicereleases-is-null',
                page: vm.page,
                size: 1000
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.devices.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.loadPage = function (page) {
            if (page <= vm.links['last']) {
                vm.page = page;
                vm.loadAll();
            }
        };

        vm.loadAll();
    }
})();
